import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { applyDynamicMultiplier } from '../other/DynamicPricing';
import { onValue } from "firebase/database";

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
        return {
            latitude: point[0],
            longitude: point[1]
        }
    });
    
    onValue(settingsRef, settingdata => {
      let settings = settingdata.val();
      let distance = settings.convert_to_mile? (res.distance_in_km / 1.609344) : res.distance_in_km;

     let {totalCost, grandTotal, convenience_fees} = FareCalculator(distance, res.time_in_secs, bookingData.carDetails, bookingData.instructionData, settings.decimal);

     const baseFare = grandTotal ? parseFloat(parseFloat(grandTotal).toFixed(settings.decimal)) : 0;
     const baseConvenience = convenience_fees ? parseFloat(parseFloat(convenience_fees).toFixed(settings.decimal)) : 0;

     const dynamicMultiplier = bookingData?.dynamicPricing?.multiplier || 1;
     const dynamicFare = dynamicMultiplier && dynamicMultiplier !== 1
       ? applyDynamicMultiplier(baseFare, dynamicMultiplier, settings.decimal)
       : baseFare;
     const dynamicConvenience = dynamicMultiplier && dynamicMultiplier !== 1
       ? applyDynamicMultiplier(baseConvenience, dynamicMultiplier, settings.decimal)
       : baseConvenience;

     const microPercent = bookingData?.microPromoPercent || bookingData?.microPromo?.percent || 0;
     const microDiscount = microPercent > 0
       ? parseFloat((dynamicFare * microPercent / 100).toFixed(settings.decimal))
       : 0;
     const finalFare = microPercent > 0
       ? parseFloat((dynamicFare - microDiscount).toFixed(settings.decimal))
       : dynamicFare;
     
      dispatch({
        type: FETCH_ESTIMATE_SUCCESS,
        payload: {
          pickup:bookingData.pickup,
          drop:bookingData.drop,
          carDetails:bookingData.carDetails,
          instructionData: bookingData.instructionData,
          estimateDistance: parseFloat(parseFloat(distance).toFixed(settings.decimal)),
          fareCost: totalCost ? parseFloat(parseFloat(totalCost).toFixed(settings.decimal)) : 0,
          estimateFare: finalFare,
          estimateTime:res.time_in_secs,
          convenience_fees: dynamicConvenience,
          waypoints: waypoints,
          originalFare: baseFare,
          dynamicFare: dynamicFare,
          dynamicMultiplier: dynamicMultiplier,
          microPromoPercent: microPercent,
          microPromoDiscount: microDiscount,
          dynamicPricing: bookingData?.dynamicPricing || null
        },
      });
    }, {onlyOnce:true});
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
